// Status pill for a booking. Matches the badge style used across the CRM.
import React from 'react';
import styled from 'styled-components';
import { statusMeta } from '../utils/scheduleUtils';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 700;
  background: ${p => p.$color}22;
  color: ${p => p.$color};
  white-space: nowrap;
`;

const StatusBadge = ({ status }) => {
  const meta = statusMeta(status);
  return <Badge $color={meta.color}>{meta.icon} {meta.label}</Badge>;
};

export default StatusBadge;
